import React, { FC } from 'react'
import classNames from 'classnames'
import parseInt from 'lodash/parseInt'
import { Case, Default, Switch } from 'react-if'
import { RelativeTimeDisplay } from '@/atoms/RelativeTimeDisplay'
import { CaptionMD, TitleXS } from '@/atoms/Text'
import { Avatar } from '@/molecules/Avatar'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'
import { PlayableStory } from '@/utils/StoryUtil'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

interface MomentStoryPlayerHeaderProps {
  projectName?: string
  story: PlayableStory
  userName?: string | null
}

export const MomentStoryPlayerHeader: FC<MomentStoryPlayerHeaderProps> = ({ projectName, story, userName }) => {
  const { t } = useTranslate('watch')
  const storyPublishDate = new Date(parseInt(story.publishDate as string))

  return (
    <div className="flex items-center gap-x-3 p-3">
      <div
        className={classNames(
          story.isFromActor && 'border border-black rounded-full ring-black ring-offset-copper ring-offset-2 ring-1',
          'mr-2',
        )}
      >
        <Avatar
          size={48}
          src={
            story?.userAvatar ??
            getCloudinaryImageUrl({ path: '/v1682448343/angel-studios/avatar-square', height: 48, width: 48 })
          }
        />
      </div>
      <div className="flex flex-col gap-y-1">
        {storyPublishDate && (
          <RelativeTimeDisplay date={storyPublishDate}>
            {(relativeTime) => <CaptionMD className="first-letter:uppercase">{relativeTime}</CaptionMD>}
          </RelativeTimeDisplay>
        )}

        <TitleXS weight="bold" color="white">
          <Switch>
            <Case condition={!!userName}>
              <Translate i18nKey="userName" t={t} values={{ userName }}>
                {{ userName }}
              </Translate>
            </Case>
            <Case condition={story.isFromActor}>
              <Translate t={t} i18nKey="actorNameDefault">
                {{ projectName }}: Actor
              </Translate>
            </Case>
            <Default>
              <Translate i18nKey="angelFan" t={t}>
                {{ projectName }}: Fan
              </Translate>
            </Default>
          </Switch>
        </TitleXS>
      </div>
    </div>
  )
}
